import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { contactMethodOptions, sessionModeOptions } from '../../../types/coach/dropdown-options';
import { PD, SF } from './tokens';

interface EditSessionFormProps {
  sessionMode: string;
  setSessionMode: (_v: string) => void;
  location: string;
  setLocation: (_v: string) => void;
  contactMethod: string;
  setContactMethod: (_v: string) => void;
  sessionTime: Date | null;
  setSessionTime: (_d: Date | null) => void;
  notes: string;
  setNotes: (_v: string) => void;
}

const labelStyle: React.CSSProperties = {
  fontFamily: SF,
  fontSize: 10.5,
  fontWeight: 700,
  color: PD.ink3,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  marginBottom: 6,
  display: 'block'
};

const EditSessionForm: React.FC<EditSessionFormProps> = ({
  sessionMode,
  setSessionMode,
  location,
  setLocation,
  contactMethod,
  setContactMethod,
  sessionTime,
  setSessionTime,
  notes,
  setNotes
}) => {
  const showLocation = sessionMode === 'presencial' || sessionMode === 'hibrido';
  const showContact = sessionMode === 'virtual_sincronico' || sessionMode === 'hibrido';
  const showTime = sessionMode === 'presencial' || sessionMode === 'virtual_sincronico' || sessionMode === 'hibrido';

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        background: PD.bg
      }}
    >
      <div
        style={{
          padding: 22,
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
          maxWidth: 520,
          margin: '0 auto',
          width: '100%'
        }}
      >
        <div
          style={{
            fontFamily: SF,
            fontSize: 11,
            fontWeight: 700,
            color: PD.ink3,
            letterSpacing: 0.5,
            textTransform: 'uppercase'
          }}
        >
          Editar información de la sesión
        </div>

        <div>
          <label style={labelStyle}>Tipo de sesión</label>
          <Dropdown
            className="pd-edit-input"
            value={sessionMode}
            options={sessionModeOptions}
            onChange={(e) => setSessionMode(e.value)}
            placeholder="Seleccionar"
          />
        </div>

        {(showLocation || showContact) && (
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {showLocation && (
              <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                <label style={labelStyle}>Ubicación</label>
                <InputText className="pd-edit-input" value={location} onChange={(e) => setLocation(e.target.value)} />
              </div>
            )}
            {showContact && (
              <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                <label style={labelStyle}>Método de contacto</label>
                <Dropdown
                  className="pd-edit-input"
                  value={contactMethod}
                  options={contactMethodOptions}
                  onChange={(e) => setContactMethod(e.value)}
                  placeholder="Seleccionar"
                />
              </div>
            )}
          </div>
        )}

        {showTime && (
          <div style={{ maxWidth: 220 }}>
            <label style={labelStyle}>Hora</label>
            <Calendar
              className="pd-edit-input"
              value={sessionTime}
              onChange={(e) => setSessionTime((e.value as Date) ?? null)}
              timeOnly
              hourFormat="24"
            />
          </div>
        )}

        <div>
          <label style={labelStyle}>Notas</label>
          <InputTextarea
            className="pd-edit-textarea"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            autoResize
          />
        </div>
      </div>
    </div>
  );
};

export default EditSessionForm;
